import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Button, Card, Input, Space, Typography } from 'antd';
import { getLicense } from '../services/api';

const { Title, Paragraph, Text } = Typography;

/**
 * 测试页面，用于排查ID解析问题
 */
const TestLicenseView = () => {
  const { id: pathId } = useParams();
  const location = useLocation();
  const [queryId, setQueryId] = useState('');
  const [customId, setCustomId] = useState('');
  const [testResults, setTestResults] = useState([]);
  
  useEffect(() => {
    // 从URL查询参数解析ID
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    if (id) {
      setQueryId(id);
    }
    
    document.title = '营业执照参数测试';
  }, [location.search]);
  
  // 添加测试结果
  const addResult = (title, content, success = true) => {
    setTestResults(prev => [
      { title, content, success, time: new Date().toLocaleTimeString() },
      ...prev
    ]);
  };
  
  // 测试从路径参数获取的ID
  const testPathId = async () => {
    if (!pathId) {
      addResult('路径参数测试', '无路径参数', false);
      return;
    }
    
    try {
      addResult('路径参数', `原始ID: ${pathId}`);
      const encoded = encodeURIComponent(pathId);
      addResult('路径参数', `编码后: ${encoded}`);
      
      const response = await getLicense(pathId);
      addResult('路径参数API调用', `成功: ${JSON.stringify(response.data)}`);
    } catch (error) {
      addResult('路径参数API调用', `失败: ${error.message}`, false);
    }
  };
  
  // 测试从查询参数获取的ID
  const testQueryId = async () => {
    if (!queryId) {
      addResult('查询参数测试', '无查询参数', false);
      return;
    }
    
    try {
      addResult('查询参数', `原始ID: ${queryId}`);
      const encoded = encodeURIComponent(queryId);
      addResult('查询参数', `编码后: ${encoded}`);
      
      const response = await getLicense(queryId);
      addResult('查询参数API调用', `成功: ${JSON.stringify(response.data)}`);
    } catch (error) {
      addResult('查询参数API调用', `失败: ${error.message}`, false);
    }
  };
  
  // 测试自定义输入的ID
  const testCustomId = async () => {
    if (!customId) {
      addResult('自定义ID测试', '请输入ID', false);
      return;
    }
    
    try {
      addResult('自定义ID', `原始ID: ${customId}`);
      const encoded = encodeURIComponent(customId);
      addResult('自定义ID', `编码后: ${encoded}`);
      
      const response = await getLicense(customId);
      addResult('自定义ID API调用', `成功: ${JSON.stringify(response.data)}`);
    } catch (error) {
      addResult('自定义ID API调用', `失败: ${error.message}`, false);
    }
  };
  
  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto' }}>
      <Title level={2}>营业执照ID参数测试</Title>
      
      <Card title="路径参数测试" style={{ marginBottom: 16 }}>
        <Paragraph>
          路径ID: <Text code>{pathId || '无'}</Text>
        </Paragraph>
        <Button type="primary" onClick={testPathId} disabled={!pathId}>
          测试路径参数
        </Button>
      </Card>
      
      <Card title="查询参数测试" style={{ marginBottom: 16 }}>
        <Paragraph>
          查询ID: <Text code>{queryId || '无'}</Text>
        </Paragraph>
        <Button type="primary" onClick={testQueryId} disabled={!queryId}>
          测试查询参数
        </Button>
      </Card>
      
      <Card title="自定义ID测试" style={{ marginBottom: 16 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Input 
            value={customId}
            onChange={e => setCustomId(e.target.value)}
            placeholder="输入营业执照ID进行测试"
          />
          <Button type="primary" onClick={testCustomId} disabled={!customId}>
            测试自定义ID
          </Button>
        </Space>
      </Card>
      
      <Card title="测试结果" style={{ marginBottom: 16 }}>
        {testResults.length === 0 ? (
          <Paragraph>暂无测试结果</Paragraph>
        ) : (
          testResults.map((result, index) => (
            <div 
              key={index} 
              style={{ 
                padding: '8px 0', 
                borderBottom: index < testResults.length - 1 ? '1px solid #f0f0f0' : 'none',
                color: result.success ? 'inherit' : '#ff4d4f'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Text strong>{result.title}</Text>
                <Text type="secondary">{result.time}</Text>
              </div>
              <Paragraph style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                {result.content}
              </Paragraph>
            </div>
          ))
        )}
      </Card>
    </div>
  );
};

export default TestLicenseView; 